export default "__VITE_ASSET__CLxRj_O0__"